///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component } from '@angular/core';
import { AbstractDialogManager } from '../../../dialog-manager/abstract-dialog-manager';
import { SuiCustomerRestrictionsDTO } from '../../../generated/shared-sui-types.model';
import { CustomerRestrictionsDialogComponent } from './customer-restrictions-dialog.component';

@Component({
    selector: 'winde-customer-restrictions-popup-component',
    template: '',
    standalone: false
})
export class EditCustomerRestrictionsDialogWrapperComponent extends AbstractDialogManager<
    SuiCustomerRestrictionsDTO,
    CustomerRestrictionsDialogComponent
> {
    constructor() {
        super(CustomerRestrictionsDialogComponent);
        this.openDialog();
    }

    preparingBaseConfig(): void {
        this.baseConfig.width = '800px';
        this.baseConfig.position = { top: '30px' };
    }
}
